import './App.css';
import React, { useEffect, useState } from 'react';
import { Earth } from './components/earth';
import main_bg from './assets/main_bg.svg';

const setWithExpiry = (key, value, timeout) => {
  const now = new Date();
  const item = {
    value: value,
    expiry: now.getTime() + timeout, // Current time + timeout in milliseconds
  };
  localStorage.setItem(key, JSON.stringify(item));
};

const getWithExpiry = (key) => {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  try {
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  } catch (error) {
    console.error('Error parsing localStorage item:', error);
    return null;
  }
};

const LOGIN_TIMEOUT = 60 * 60 * 1000; // 1 hour in milliseconds

export function App() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const loginState = getWithExpiry('isLoggedIn');
    if (loginState) {
      setIsLoggedIn(true);
      const remainingTime = loginState.expiry - new Date().getTime();
      if (remainingTime < 15 * 60 * 1000) {
        setWithExpiry('isLoggedIn', true, LOGIN_TIMEOUT);
      }
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    // if (username === 'admin' && password === 'password') {
    //   setIsLoggedIn(true);
    //   setWithExpiry('isLoggedIn', true, LOGIN_TIMEOUT);
    // } else {
    //   alert('Invalid credentials. Please try again.');
    // }
    try {
      const response = await fetch('https://nodered.greenheroes.co/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      if (!response.ok) {
        throw new Error('Login failed');
      }

      const data = await response.json();
      console.debug({ data, zxc: data.success });

      if (data.success) {
        setIsLoggedIn(true);
        setWithExpiry('isLoggedIn', true, LOGIN_TIMEOUT);
      } else {
        alert(data.message || 'Invalid credentials. Please try again.');
      }
    } catch (error) {
      console.error('Error during login:', error);
      alert('An error occurred while logging in. Please try again later.');
    }
  };

  if (isLoggedIn) {
    return <Earth />;
  }

  return (
    <div style={styles.container}>
      <form onSubmit={handleLogin} style={styles.form}>
        <div style={styles.inputGroup}>
          <label style={styles.label} htmlFor="username">
            Username
          </label>
          <input
            style={styles.input}
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div style={styles.inputGroup}>
          <label style={styles.label} htmlFor="password">
            Password
          </label>
          <input
            style={styles.input}
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" style={styles.button}>
          Sign in
        </button>
      </form>
    </div>
  );
}

const styles = {
  container: {
    backgroundImage: `url(${main_bg})`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: '#f5f5f5',
    padding: '20px',
  },
  title: {
    marginBottom: '20px',
    fontSize: '1.5em',
    textAlign: 'center',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#fff',
    padding: '20px 30px',
    borderRadius: '5px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    width: '100%',
    maxWidth: '350px',
    boxSizing: 'border-box',
  },
  inputGroup: {
    marginBottom: '15px',
    width: '100%',
  },
  label: {
    display: 'block',
    marginBottom: '5px',
    fontSize: '0.9em',
  },
  input: {
    width: '100%',
    padding: '10px',
    borderRadius: '1px',
    border: '1px solid #ccc',
    fontSize: '1em',
    boxSizing: 'border-box',
  },
  button: {
    marginTop: '20px',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '5px',
    backgroundColor: '#E77D11',
    color: '#fff',
    cursor: 'pointer',
    fontSize: '1em',
    width: '100%',
  },
};

export default App;
